type SpacerRowProps = {
    height: number
    colSpan: number
}

/**
 * Preserves the scroll height of virtualized (unmounted) rows above or below
 * the visible window. A single <tr> keeps the table markup valid; block
 * display matches the grid/block layout DataTable rows already use and
 * avoids anonymous table boxes. Must not carry borders: spacer height is
 * exact pitch math, see the shared useVirtualizeRows hook in src/hooks.
 */
export const SpacerRow = ({ height, colSpan }: SpacerRowProps) => (
    <tr aria-hidden="true" data-test="spacer-row" style={{ height, display: 'block', border: 0, padding: 0 }}>
        <td aria-hidden="true" colSpan={colSpan} style={{ height, padding: 0, border: 0, display: 'block' }} />
    </tr>
)
